import { useIsHydrated } from "../use-is-hydrated.js";
import { getComparativeReadableDate } from "../utils.js";
import { Translation } from "../i18n/translation.js";
import { useLocale } from "../i18n/use-locale.js";

export function RelativeTime({ date }: { date?: Date }) {
  const isHydrated = useIsHydrated();
  const locale = useLocale();

  if (!date) {
    return (
      <>
        <Translation
          defaultMessage="Never"
          id="yXCbRa"
          description="Text indicating API key was never used"
        />
      </>
    );
  }

  return (
    <>
      {isHydrated
        ? getComparativeReadableDate(new Date(), date, { locale })
        : date.toLocaleDateString(locale, {
            month: "short",
            day: "numeric",
            year: "numeric",
          })}
    </>
  );
}
